import { render, staticRenderFns } from "./InvoicePaidList.vue?vue&type=template&id=18669d58&"
import script from "./InvoicePaidList.vue?vue&type=script&lang=js&"
export * from "./InvoicePaidList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports